export const FACTORY_CONTRACT = "terra1kls65zhgtura0aydnhvtwj6suwrvg30lc2djyr";
export const PAIR_CONTRACT = "terra1esmts7ps6pdazy6k4s22e93cwuc6y0v6gkvyt8";

// Mainnet LBP variables
// export const FACTORY_CONTRACT = "terra1d0elgfj87ee6cuw2ep3ajj6kxuprmvh0k0qxd2";
// export const PAIR_CONTRACT = "terra1kysr9lkx30mlwx8ugnekv55xsskyshp8ved4xh";
